import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: 'fas fa-mobile-alt',
      title: 'Android App Development',
      description: 'Build powerful, scalable Android applications with modern frameworks. We create native and cross-platform apps that deliver exceptional user experiences.',
      features: ['Native Android Development', 'Kotlin & Java', 'Material Design', 'Play Store Optimization'],
      link: '/services/android-app-development'
    },
    {
      icon: 'fas fa-mobile-alt',
      title: 'Flutter App Development',
      description: 'Cross-platform mobile app development with Flutter. Build beautiful, high-performance apps for both Android and iOS from a single codebase at affordable prices.',
      features: ['Cross-Platform Development', 'Single Codebase', 'Fast Performance', 'Cost-Effective Solutions'],
      link: '/services/flutter-app-development'
    },
    {
      icon: 'fas fa-globe',
      title: 'Web Development',
      description: 'Create stunning, responsive websites and web applications. From simple landing pages to complex enterprise solutions, we bring your vision to life.',
      features: ['React & Next.js', 'Node.js Backend', 'Responsive Design', 'SEO Optimization'],
      link: '/services/web-development'
    },
    {
      icon: 'fab fa-wordpress',
      title: 'WordPress Development',
      description: 'Custom WordPress solutions tailored to your needs. We build themes, plugins, and full-featured websites that are fast, secure, and easy to manage.',
      features: ['Custom Themes', 'Plugin Development', 'E-commerce Solutions', 'Performance Optimization'],
      link: '/services/wordpress-development'
    },
    {
      icon: 'fas fa-palette',
      title: 'UI/UX for App & Web',
      description: 'Design beautiful, intuitive interfaces that users love. Our design process focuses on user research, wireframing, and creating pixel-perfect designs.',
      features: ['User Research', 'Wireframing & Prototyping', 'Design Systems', 'Usability Testing'],
      link: '/services/ui-ux-design'
    },
    {
      icon: 'fab fa-apple',
      title: 'iOS Development',
      description: 'Build stunning, high-performance iOS applications for iPhone and iPad. We create native iOS apps using Swift and SwiftUI that deliver exceptional user experiences.',
      features: ['Native iOS Development', 'Swift & SwiftUI', 'App Store Optimization', 'iOS Design Guidelines'],
      link: '/services/ios-development'
    },
    {
      icon: 'fas fa-robot',
      title: 'AI Chatbots & Smart Tools',
      description: 'Leverage the power of artificial intelligence to create intelligent chatbots and smart automation tools. Enhance customer engagement and streamline business processes.',
      features: ['AI Chatbot Development', 'Natural Language Processing', 'Automation Tools', 'Machine Learning Integration'],
      link: '/services/ai-chatbots-smart-tools'
    }
  ];

  return (
    <section id="services" className="services">
      <div className="services-container">
        <div className="services-header">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">What We Do</p>
          <p className="section-description">
            We offer comprehensive digital solutions to help your business thrive in the digital age.
            From mobile apps to web platforms, we've got you covered.
          </p>
        </div>
        <div className="servicesGrid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                <i className={service.icon}></i>
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx}>
                    <i className="fas fa-check-circle"></i>
                    {feature}
                  </li>
                ))}
              </ul>
              <Link to={service.link} className="service-button">Learn More</Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;

